export const SUPPORTED_LANGUAGES: { [key: string]: string } = {
  'en-US': 'English (United States)',
  'es-US': 'Spanish (United States)', 
  'fr-FR': 'French (France)',
  'de-DE': 'German (Germany)',
  'it-IT': 'Italian (Italy)',
  'pt-BR': 'Portuguese (Brazil)',
  'ja-JP': 'Japanese (Japan)',
  'ko-KR': 'Korean (Korea)',
  'zh-CN': 'Chinese (Simplified)',
  'ar-SA': 'Arabic (Saudi Arabia)',
  'ru-RU': 'Russian (Russia)',
  'hi-IN': 'Hindi (India)',
  'th-TH': 'Thai (Thailand)',
  'vi-VN': 'Vietnamese (Vietnam)',
  'tr-TR': 'Turkish (Turkey)',
  'pl-PL': 'Polish (Poland)',
  'nl-NL': 'Dutch (Netherlands)',
  'sv-SE': 'Swedish (Sweden)',
  'da-DK': 'Danish (Denmark)',
  'no-NO': 'Norwegian (Norway)'
};

export const EVALUATED_COMBINATIONS = [
  { source: 'en-US', targets: ['es-US', 'fr-FR', 'de-DE'] },
  { source: 'es-US', targets: ['en-US', 'pt-BR'] },
  { source: 'fr-FR', targets: ['en-US', 'es-US'] }
];

export const GCP_CONFIG = {
  SUPPORTED_REGIONS: [
    'asia-northeast1',
    'asia-south1', 
    'asia-southeast1',
    'europe-west1',
    'europe-west3',
    'europe-west4',
    'us-central1',
    'us-east1',
    'us-west1'
  ],
  DEFAULT_REGION: 'us-central1',
  MAX_DURATION_HOURS: 1,
  MAX_FILE_SIZE_GB: 10,
  SUPPORTED_VIDEO_FORMATS: ['mp4', 'mov', 'avi', 'mkv'],
  SUPPORTED_SUBTITLE_FORMATS: ['srt']
};

export const JOB_STATUS_COLORS = {
  pending: '#f59e0b',
  processing: '#3b82f6',
  completed: '#10b981',
  failed: '#ef4444'
};

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    VERIFY: '/auth/verify'
  },
  JOBS: {
    LIST: '/jobs',
    CREATE: '/jobs',
    GET: (id: string) => `/jobs/${id}`,
    DELETE: (id: string) => `/jobs/${id}`,
    STATUS: (id: string) => `/jobs/${id}/status`,
    LOGS: (id: string) => `/jobs/${id}/logs`
  },
  FILES: {
    UPLOAD_VIDEO: '/upload/video',
    UPLOAD_SUBTITLES: '/upload/subtitles',
    DOWNLOAD: (jobId: string, type: string) => `/download/${jobId}/${type}`,
    STREAM: (jobId: string) => `/stream/${jobId}`
  }
};

